
export const COUNTRY_CODES = [
    { code: '+1', name: 'Estados Unidos/Canadá', iso: 'US' },
    { code: '+44', name: 'Reino Unido', iso: 'GB' },
    { code: '+34', name: 'España', iso: 'ES' },
    { code: '+52', name: 'México', iso: 'MX' },
    { code: '+57', name: 'Colombia', iso: 'CO' },
    { code: '+49', name: 'Alemania', iso: 'DE' },
    { code: '+33', name: 'Francia', iso: 'FR' },
    { code: '+55', name: 'Brasil', iso: 'BR' },
    { code: '+81', name: 'Japón', iso: 'JP' },
    { code: '+86', name: 'China', iso: 'CN' },
    { code: '+91', name: 'India', iso: 'IN' },
    { code: '+7', name: 'Rusia', iso: 'RU' },
    { code: '+61', name: 'Australia', iso: 'AU' },
    { code: '+39', name: 'Italia', iso: 'IT' },
    { code: '+351', name: 'Portugal', iso: 'PT' },
    { code: '+90', name: 'Turquía', iso: 'TR' },
    { code: '+82', name: 'Corea del Sur', iso: 'KR' },
    { code: '+62', name: 'Indonesia', iso: 'ID' },
    { code: '+20', name: 'Egipto', iso: 'EG' },
    { code: '+212', name: 'Marruecos', iso: 'MA' },

];
